import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { FeatureFlagService } from '@services/feature-flag.service';

const MARKETPLACE_PATH = '/collection/marketplace';
const MAINTENANCE_PATH = '/collection/marketplace/maintenance';

/**
 * Page marketplace : accessible seulement si le flag MARKETPLACE est strictement
 * ENABLED (BETA_TEST / DISABLED comptent comme coupé, cf. enforcement binaire
 * côté back). Sinon on redirige vers la page de maintenance.
 */
export const marketplaceEnabledGuard: CanMatchFn = () => {
	const featureFlagService = inject(FeatureFlagService);
	const router = inject(Router);

	return featureFlagService.getFeatureFlags().pipe(
		take(1),
		map(() => featureFlagService.isStrictlyEnabled('MARKETPLACE')
			? true
			: router.parseUrl(MAINTENANCE_PATH)),
	);
};

/** Page de maintenance : n'a de sens que si le marketplace est coupé ; sinon retour au marketplace. */
export const marketplaceMaintenanceGuard: CanMatchFn = () => {
	const featureFlagService = inject(FeatureFlagService);
	const router = inject(Router);

	return featureFlagService.getFeatureFlags().pipe(
		take(1),
		map(() => featureFlagService.isStrictlyEnabled('MARKETPLACE')
			? router.parseUrl(MARKETPLACE_PATH)
			: true),
	);
};
